import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const PLACES = ["first", "second", "third"];
export const PTS = { first: 3, second: 2, third: 1 };
export const LBL = { first: "1º", second: "2º", third: "3º" };
export const ptsTxt = (n) => `${n} ${n === 1 ? "pt" : "pts"}`;
export const photoUrl = (id) => (id ? `${API}/photos/${id}` : "");
export const bg = (id) => (id ? { backgroundImage: `url("${photoUrl(id)}")` } : {});
export const isEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((e || "").trim());
export const VOTE_DOMAINS = ["@trafalgar.mx", "@trfbolsa.mx", "@trf.com", "@jstrust.mx", "@trfcards.com", "@serviciosdigitalestr.com", "@tsf.com"];
export const canVoteEmail = (e) => VOTE_DOMAINS.some((d) => (e || "").trim().toLowerCase().endsWith(d));
export const errMsg = (e) =>
  e?.response?.data?.detail && typeof e.response.data.detail === "string"
    ? e.response.data.detail
    : "No se pudo guardar. Revisa tu conexión e inténtalo de nuevo.";

export const api = {
  state: (email) => axios.get(`${API}/state`, { params: email ? { email } : {} }).then((r) => r.data),
  saveEntry: (fd) => axios.post(`${API}/entries`, fd),
  saveVote: (body) => axios.put(`${API}/votes`, body),
  setConfig: (body) => axios.put(`${API}/admin/config`, body),
  removeEntry: (id, email) => axios.delete(`${API}/admin/entries/${id}`, { params: { email } }),
};

export async function compress(file) {
  try {
    const url = URL.createObjectURL(file);
    const img = await new Promise((res, rej) => {
      const i = new Image();
      i.onload = () => res(i);
      i.onerror = rej;
      i.src = url;
    });
    const max = 1400, k = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
    const c = document.createElement("canvas");
    c.width = Math.round(img.naturalWidth * k);
    c.height = Math.round(img.naturalHeight * k);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    URL.revokeObjectURL(url);
    const b = await new Promise((r) => c.toBlob(r, "image/jpeg", 0.85));
    return b || file;
  } catch (_) {
    return file;
  }
}
